// ============================================================================
// ARABIC TRANSLATIONS - CHAPTER 1: سفر التكوين
// ============================================================================
// المستويات 1-13 (13 مستوى، 39 سؤالاً)

export const chapter1Translations = {
  name: "سفر التكوين",
  description: "في البدء... المعرفة تُحيي الروح",
  
  spiritualWisdom: {
    principle: "المعرفة تُحيي الروح",
    scripture: "قَدْ هَلَكَ شَعْبِي مِنْ عَدَمِ الْمَعْرِفَةِ (هوشع 4:6)",
    application: "كل آية مدروسة، كل حقيقة مكتشفة تُغذي أرواحنا وتُقوي إيماننا"
  },
  
  levels: {
    1: {
      name: "الخليقة",
      challenge: "فِي الْبَدْءِ خَلَقَ اللهُ السَّمَاوَاتِ وَالأَرْضَ...",
      easy: {
        question: "في كم يوماً خلق الله العالم؟",
        options: ["5 أيام", "6 أيام", "7 أيام", "8 أيام"],
        hint: "فكّر في يوم الراحة في الأسبوع",
        funFact: "💡 اليوم السابع استراح الله. هذا أصل السبت، يوم الراحة الأسبوعي!"
      },
      medium: {
        question: "ماذا خلق الله في اليوم الرابع؟",
        options: ["الحيوانات", "الإنسان", "الشمس والقمر والنجوم", "النباتات"],
        hint: "هذه المخلوقات تُنير الأرض وتُحدد الوقت",
        funFact: "🌟 الأنوار خُلقت لتُحدد الفصول والأعياد الدينية!"
      },
      hard: {
        question: "ماذا يعني أن الإنسان خُلق 'على صورة الله'؟",
        options: [
          "مظهر جسدي متطابق",
          "قدرة على الخلق والمحبة",
          "خلود طبيعي",
          "قوة إلهية"
        ],
        hint: "يتعلق الأمر بالصفات الروحية والفكرية",
        funFact: "✨ صورة الله فينا تشمل الإبداع والوعي الأخلاقي والقدرة على المحبة!"
      }
    },
    
    2: {
      name: "تجربة الجنة",
      challenge: "وَكَانَتِ الْحَيَّةُ أَحْيَلَ جَمِيعِ حَيَوَانَاتِ الْبَرِّيَّةِ...",
      easy: {
        question: "أي حيوان جرّب حواء في الجنة؟",
        options: ["الأسد", "الحية", "النسر", "التنين"],
        hint: "هذا الحيوان يزحف على بطنه",
        funFact: "🐍 الحية ترمز للتجربة والمكر في الكتاب المقدس كله!"
      },
      medium: {
        question: "ما الوعد الكاذب الذي قدمته الحية لحواء؟",
        options: [
          "ستكونون خالدين",
          "ستكونون أغنياء",
          "ستكونون كآلهة",
          "ستكونون سعداء"
        ],
        hint: "الحية تعد بالارتقاء إلى المستوى الإلهي",
        funFact: "🎭 كذبة الحية تمزج الحقيقة بالخداع - تقنية تجربة كلاسيكية!"
      },
      hard: {
        question: "كيف توضح هذه السقطة صراعنا بين الخير والشر؟",
        options: [
          "الشر أقوى",
          "الإرادة الحرة تعني المسؤولية",
          "الله يتركنا",
          "التجربة لا تُقهر"
        ],
        hint: "يتعلق الأمر بقدرتنا على الاختيار وتحمل العواقب",
        funFact: "🌳 شجرة المعرفة ترمز للاختيار الأخلاقي الذي يُحدد الإنسانية!"
      }
    },
    
    3: {
      name: "قايين وهابيل",
      challenge: "أخوان، قربانان، مأساة أبدية...",
      easy: {
        question: "من كان أول قاتل في التاريخ الكتابي؟",
        options: ["هابيل", "شيث", "قايين", "آدم"],
        hint: "الأخ الغيور من هابيل",
        funFact: "⚡ قايين أصبح رمز الغيرة الأخوية المدمّرة!"
      },
      medium: {
        question: "لماذا فضّل الله قربان هابيل؟",
        options: [
          "كمية أكبر",
          "هابيل كان أجمل",
          "قُدّم بقلب صادق",
          "كان لحماً"
        ],
        hint: "الله ينظر إلى القلب",
        funFact: "❤️ الله ينظر إلى القلب، ليس فقط إلى مظهر أفعالنا!"
      },
      hard: {
        question: "ما الذي تُعلّمنا إياه هذه القصة عن الغيرة؟",
        options: [
          "الغيرة طبيعية",
          "الغيرة غير المسيطر عليها تؤدي إلى الدمار",
          "الله يُفضّل البعض",
          "المنافسة صحية"
        ],
        hint: "يتعلق الأمر بعواقب عدم التحكم في عواطفنا",
        funFact: "🔥 'الْخَطِيَّةُ رَابِضَةٌ عِنْدَ الْبَابِ' - الله يُحذّرنا قبل السقوط!"
      }
    },

    4: {
      name: "طوفان نوح",
      challenge: "وَكَانَ الْمَطَرُ عَلَى الأَرْضِ أَرْبَعِينَ يَوْمًا وَأَرْبَعِينَ لَيْلَةً...",
      easy: {
        question: "كم يوماً وليلة استمر مطر الطوفان؟",
        options: ["30 يوماً", "40 يوماً", "50 يوماً", "100 يوم"],
        hint: "رقم رمزي في الكتاب المقدس",
        funFact: "☔ الرقم 40 يرمز للتجربة والتحوّل في الكتاب المقدس!"
      },
      medium: {
        question: "كم من الحيوانات الطاهرة كان على نوح أن يأخذ في الفلك؟",
        options: [
          "زوج واحد",
          "زوجان",
          "7 أزواج",
          "10 أزواج"
        ],
        hint: "أكثر من الحيوانات غير الطاهرة",
        funFact: "🦁 الحيوانات الطاهرة كانت مُعدّة للذبائح بعد الطوفان!"
      },
      hard: {
        question: "ماذا يرمز الفلك في مسيرتنا الروحية؟",
        options: [
          "الهروب من المشاكل",
          "الخلاص بالإيمان والطاعة",
          "العزلة الضرورية",
          "تفوق المؤمنين"
        ],
        hint: "يتعلق الأمر بالخلاص المقدّم للذين يؤمنون",
        funFact: "🚢 الفلك يُنبئ بالخلاص: طريق واحد للهروب من الدينونة!"
      }
    },

    5: {
      name: "برج بابل",
      challenge: "هَلُمَّ نَبْنِ لأَنْفُسِنَا بُرْجًا رَأْسُهُ بِالسَّمَاءِ...",
      easy: {
        question: "ماذا بلبل الله في بابل؟",
        options: ["الخطط", "الألسنة", "الأدوات", "الأفكار"],
        hint: "ما يسمح بالتواصل",
        funFact: "🗣️ بابل هي الأصل الأسطوري للتنوع اللغوي العالمي!"
      },
      medium: {
        question: "لماذا أراد الناس بناء هذا البرج؟",
        options: [
          "للحماية",
          "للعيش معاً",
          "لصنع اسم لأنفسهم والوصول إلى السماء",
          "لتكريم الله"
        ],
        hint: "يتعلق الأمر بالكبرياء ومحاولة مساواة الله",
        funFact: "🏗️ كبرياء محاولة مساواة الله تؤدي دائماً إلى الارتباك!"
      },
      hard: {
        question: "كيف يتجلى كبرياء بابل اليوم؟",
        options: [
          "في التكنولوجيا فقط",
          "في إرادة الإنسان للاستقلال المطلق بدون الله",
          "في ناطحات السحاب",
          "في اللغات المختلفة"
        ],
        hint: "يتعلق الأمر بمحاولة الاستغناء عن الله",
        funFact: "💭 بابل تُذكّرنا أن الوحدة بدون الله تصبح كبرياء مدمّراً!"
      }
    },

    6: {
      name: "دعوة إبراهيم",
      challenge: "اذْهَبْ مِنْ أَرْضِكَ وَمِنْ عَشِيرَتِكَ وَمِنْ بَيْتِ أَبِيكَ...",
      easy: {
        question: "كم كان عمر إبراهيم عندما ترك بلاده؟",
        options: ["50 سنة", "65 سنة", "75 سنة", "100 سنة"],
        hint: "سن متقدم جداً للبدء من جديد",
        funFact: "🚶 في سن 75، بدأ إبراهيم حياة جديدة - لم يفت الأوان أبداً!"
      },
      medium: {
        question: "ما الوعد الثلاثي الذي قطعه الله لإبراهيم؟",
        options: [
          "ثروة، قوة، حكمة",
          "أرض، نسل، بركة عالمية",
          "حياة طويلة، سلام، رخاء",
          "إيمان، رجاء، محبة"
        ],
        hint: "وعد يخص البشرية جمعاء",
        funFact: "🌟 الوعد لإبراهيم يخص البشرية جمعاء، ليس فقط هو!"
      },
      hard: {
        question: "ماذا تُعلّمنا 'قفزة الإيمان' لإبراهيم؟",
        options: [
          "الإيمان الأعمى خطير",
          "اتباع الله يتطلب ترك ضماناتنا",
          "الله يُفضّل شعوباً معينة",
          "الإيمان يضمن النجاح"
        ],
        hint: "يتعلق الأمر بالثقة بترك مرجعياتنا",
        funFact: "✨ إبراهيم يُدعى 'أب الإيمان' لأنه آمن دون أن يرى!"
      }
    },

    7: {
      name: "تقديم إسحاق",
      challenge: "خُذِ ابْنَكَ وَحِيدَكَ، الَّذِي تُحِبُّهُ...",
      easy: {
        question: "على أي جبل كان على إبراهيم أن يُقدّم إسحاق؟",
        options: ["سيناء", "المُريّا", "الكرمل", "صهيون"],
        hint: "هذا الجبل سيصبح مكاناً مقدساً",
        funFact: "🏔️ جبل المُريّا سيصبح موقع هيكل أورشليم!"
      },
      medium: {
        question: "ماذا قدّم الله بدلاً من إسحاق؟",
        options: [
          "حَمَل",
          "كَبْش ممسك بقرنيه",
          "ماعز",
          "ثور"
        ],
        hint: "حيوان ذكر بالغ بقرون",
        funFact: "🐏 الكبش البديل يُنبئ بالذبيحة البديلة الأخيرة!"
      },
      hard: {
        question: "كيف توضح هذه التجربة الإيمان المطلق؟",
        options: [
          "الله يختبر بقسوة",
          "الإيمان يتجاوز حتى المحبة الأبوية",
          "الذبائح البشرية ترضي الله",
          "إبراهيم لم يُحب إسحاق حقاً"
        ],
        hint: "يتعلق الأمر بالثقة حتى عندما لا نفهم",
        funFact: "💝 الله يُوفّر دائماً مخرجاً عندما نثق به!"
      }
    },

    8: {
      name: "يعقوب وعيسو",
      challenge: "الْكَبِيرُ يُسْتَعْبَدُ لِلصَّغِيرِ...",
      easy: {
        question: "مقابل ماذا باع عيسو بكوريته؟",
        options: ["ذهب", "طبق عدس", "ملابس", "نبيذ"],
        hint: "طبق لإشباع جوعه",
        funFact: "🍲 لحظة جوع كلّفت عيسو بركته الأبدية!"
      },
      medium: {
        question: "كيف خدع يعقوب أباه إسحاق؟",
        options: [
          "بتغيير صوته",
          "بالتنكر",
          "بتغطية نفسه بجلد الماعز",
          "بالكذب عن اسمه"
        ],
        hint: "ليبدو مثل أخيه المُشعر",
        funFact: "🎭 إسحاق الأعمى تعرّف على الرائحة واللمس لكن ليس على الخديعة!"
      },
      hard: {
        question: "ماذا تكشف هذه القصة عن خياراتنا؟",
        options: [
          "الخداع ضروري أحياناً",
          "الرغبات الفورية يمكن أن تُكلّفنا مصيرنا",
          "الله يُوافق على المكر",
          "الأصغر يُفضّل دائماً"
        ],
        hint: "يتعلق الأمر بعواقب قراراتنا الاندفاعية",
        funFact: "⚖️ خياراتنا الاندفاعية يمكن أن يكون لها عواقب أبدية!"
      }
    },

    9: {
      name: "حلم يعقوب",
      challenge: "وَرَأَى سُلَّمًا مَنْصُوبًا عَلَى الأَرْضِ وَرَأْسُهُ يَمَسُّ السَّمَاءَ...",
      easy: {
        question: "ماذا رأى يعقوب في حلمه؟",
        options: [
          "شجرة عملاقة",
          "سُلّماً إلى السماء مع ملائكة",
          "هيكل",
          "نجوم"
        ],
        hint: "وسيلة للتواصل بين السماء والأرض",
        funFact: "👼 سُلّم يعقوب يرمز للاتصال بين السماء والأرض!"
      },
      medium: {
        question: "ماذا فعل يعقوب بالحجر الذي كان يستخدمه كوسادة؟",
        options: [
          "كسره",
          "دفنه",
          "نصبه ومسحه بالزيت",
          "أخذه معه"
        ],
        hint: "جعله نصباً مقدساً",
        funFact: "🪨 هذا الحجر أصبح 'بيت إيل' - بيت الله!"
      },
      hard: {
        question: "كيف تربط هذه الرؤيا السماء والأرض في حياتنا؟",
        options: [
          "بالأحلام فقط",
          "بالصلاة التي تُقيم الجسر مع الإلهي",
          "بالملائكة الحراس",
          "بالأماكن المقدسة"
        ],
        hint: "يتعلق الأمر بتواصلنا مع الله",
        funFact: "🌉 الصلاة هي سُلّمنا الشخصي نحو السماء!"
      }
    },

    10: {
      name: "يوسف يُباع من إخوته",
      challenge: "هُوَذَا صَاحِبُ الأَحْلاَمِ قَادِمٌ...",
      easy: {
        question: "كم عدد إخوة يوسف؟",
        options: ["7 إخوة", "10 إخوة", "11 أخاً", "12 أخاً"],
        hint: "واحد أقل من عدد أسباط إسرائيل",
        funFact: "👨‍👨‍👦‍👦 أبناء يعقوب الـ12 سيصبحون الأسباط الـ12 لإسرائيل!"
      },
      medium: {
        question: "بكم من قطعة فضة بِيع يوسف؟",
        options: [
          "10 قطع",
          "20 قطعة",
          "30 قطعة",
          "50 قطعة"
        ],
        hint: "ثمن عبد",
        funFact: "💰 20 قطعة فضة، ثمن عبد في ذلك الوقت!"
      },
      hard: {
        question: "كيف تصبح الغيرة أداة للخطة الإلهية؟",
        options: [
          "الله يُوافق على الغيرة",
          "الشر المُرتكب يُحوّله الله إلى خير",
          "الغيرة ضرورية",
          "الإخوة كانوا على حق"
        ],
        hint: "يتعلق الأمر بالعناية الإلهية التي تُحوّل الشر",
        funFact: "🎨 الله يُحوّل حتى أسوأ أفعالنا إلى تحفة من النعمة!"
      }
    },

    11: {
      name: "يوسف في السجن",
      challenge: "وَكَانَ الرَّبُّ مَعَ يُوسُفَ وَبَسَطَ إِلَيْهِ لُطْفًا...",
      easy: {
        question: "ما الموهبة الخاصة التي كان يوسف يمتلكها؟",
        options: [
          "التنبؤ",
          "تفسير الأحلام",
          "شفاء المرضى",
          "التحدث مع الحيوانات"
        ],
        hint: "قدرة مرتبطة بالرؤى",
        funFact: "💭 الأحلام كانت تُعتبر رسائل إلهية في العصور القديمة!"
      },
      medium: {
        question: "أي خدّام لفرعون كانوا في السجن مع يوسف؟",
        options: [
          "الوزير والكاتب",
          "ساقي الخمر والخبّاز",
          "الطبيب والحارس",
          "الطاهي والبستاني"
        ],
        hint: "من كان يُقدّم النبيذ ومن كان يُقدّم الخبز",
        funFact: "🍷 الساقي كان يتذوق نبيذ الملك لتجنب التسميم!"
      },
      hard: {
        question: "ماذا يُعلّمنا يوسف عن الأمانة في الشدائد؟",
        options: [
          "الظلم مقبول",
          "الأمانة لله تتجاوز الظروف",
          "السجن يُغيّر الناس",
          "يجب الانتقام"
        ],
        hint: "يتعلق الأمر بالبقاء أميناً حتى في التجارب",
        funFact: "⭐ حتى في السجن، بقي يوسف نزيهاً والله رفعه!"
      }
    },

    12: {
      name: "أحلام فرعون",
      challenge: "سَبْعُ بَقَرَاتٍ سِمَانٍ... سَبْعُ بَقَرَاتٍ عِجَافٍ...",
      easy: {
        question: "كم بقرة عجفاء أكلت البقرات السمان؟",
        options: ["5", "6", "7", "8"],
        hint: "رقم كامل",
        funFact: "🐄 الرقم 7 يرمز للكمال والتمام في الكتاب المقدس!"
      },
      medium: {
        question: "ماذا كانت تعني الـ7 سنوات في الحلم؟",
        options: [
          "7 سنوات حرب ثم سلام",
          "7 سنوات وفرة ثم 7 سنوات مجاعة",
          "7 سنوات مرض ثم صحة",
          "7 سنوات مطر ثم جفاف"
        ],
        hint: "دورة من الوفرة والندرة",
        funFact: "🌾 يوسف أنقذ مصر وعائلته بفضل هذا التفسير!"
      },
      hard: {
        question: "كيف تُحوّل الحكمة الإلهية الأزمات؟",
        options: [
          "بتجنب كل أزمة",
          "بإعطاء البصيرة للاستعداد لها",
          "بمعاقبة الأشرار",
          "بإغناء المؤمنين"
        ],
        hint: "يتعلق الأمر بالإعداد والتوقع",
        funFact: "💡 الحكمة الإلهية تُحوّل الأزمات إلى فرص للخلاص!"
      }
    },

    13: {
      name: "مصالحة الإخوة",
      challenge: "أَنَا يُوسُفُ أَخُوكُمُ الَّذِي بِعْتُمُوهُ...",
      easy: {
        question: "ماذا وضع يوسف في كيس بنيامين؟",
        options: [
          "ذهب",
          "خاتمه",
          "كأسه الفضية",
          "رسالة"
        ],
        hint: "غرض شخصي ثمين",
        funFact: "🏆 الكأس كانت تُستخدم أيضاً لـ'قراءة' المستقبل في الماء!"
      },
      medium: {
        question: "ما الجملة الشهيرة التي قالها يوسف عن الشر المُحوّل؟",
        options: [
          "أنا أسامحكم",
          "أَنْتُمْ قَصَدْتُمْ لِي شَرًّا، أَمَّا اللهُ فَقَصَدَ بِهِ خَيْرًا",
          "لننس الماضي",
          "الانتقام لله"
        ],
        hint: "جملة عن العناية الإلهية",
        funFact: "✨ هذه الجملة تُلخّص كل العناية الإلهية في حياتنا!"
      },
      hard: {
        question: "كيف يكسر المغفرة دورات الانتقام؟",
        options: [
          "بنسيان الشر",
          "بتحرير المُسيء والمُساء إليه لبداية جديدة",
          "بالمعاقبة أولاً",
          "بحفظ المسافات"
        ],
        hint: "يتعلق الأمر بالتحرير المتبادل",
        funFact: "🕊️ مغفرة يوسف تُنبئ بالمغفرة الإلهية الشاملة!"
      }
    }
  }
};

export default chapter1Translations;
